'use client'

import { Heart, HelpCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import Link from 'next/link'
import { AppInfoDialog } from './AppInfoDialog'
import { useTranslations } from 'next-intl'

export default function Footer() {
  const t = useTranslations('footer')

  return (
    <footer className="border-t border-gray-200 bg-white pt-2">
      <div className="px-4 py-6">
        <div className="flex flex-col space-y-4">
          <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
            <div className="flex items-center gap-4 text-sm text-gray-600">
              <Button variant="link" asChild className="h-auto p-0 text-sm text-gray-600">
                <Link href="https://playerhelp.playtomic.com/hc" target="_blank">
                  <HelpCircle className="mr-1 h-4 w-4" />
                  {t('help_support')}
                </Link>
              </Button>
              <AppInfoDialog />
            </div>

            <div className="flex items-center gap-2 text-sm text-gray-500">
              <span>{t('made_with')}</span>
              <Heart className="text-energy-blue h-4 w-4 fill-current" />
              <span>{t('for_coaches')}</span>
            </div>
          </div>

          <div className="border-t border-gray-100 pt-4 text-center">
            <p className="text-xs text-gray-500">{t('copyright')}</p>
          </div>
        </div>
      </div>
    </footer>
  )
}
